/** Fired by the API client when a 401 survives the token refresh: the
 * session is gone (#23). `AuthProvider` listens and sends the user to login. */
type Listener = () => void;

const listeners = new Set<Listener>();

export function notifySessionExpired(): void {
  for (const listener of listeners) listener();
}

export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
